"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserFormFields = void 0;
function browserFormFields() {
    let i, j, strFormsInputsData = [];
    const formFields = {
        url: window.location.href,
        formInputs: [],
    };
    try {
        /**
         * TODO:
         *
         * This should be converted to use `Array.from()` and then filter/map operators
         * when we deprecate support for IE11 fully. Until then, we'll loop using
         * interators i & j.
         */
        const formsInPage = document.getElementsByTagName('form');
        for (i = 0; i < formsInPage.length; i = i + 1) {
            const inputsInForm = formsInPage[i].getElementsByTagName('input');
            const formInputs = {
                name: formsInPage[i].name,
                inputs: [],
            };
            strFormsInputsData = [];
            for (j = 0; j < inputsInForm.length; j = j + 1) {
                if (inputsInForm[i].type !== 'hidden') {
                    strFormsInputsData.push(inputsInForm[j].name);
                }
            }
            formFields.formInputs.push({
                name: formInputs.name,
                inputs: strFormsInputsData,
            });
        }
    }
    catch (err) {
        /* no need to see or do anything */
    }
    return formFields;
}
exports.browserFormFields = browserFormFields;
//# sourceMappingURL=formFields.js.map